
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 21.5q-1.05 0-1.775-.725Q15.5 20.05 15.5 19q0-.2.038-.413.037-.212.112-.412l-7.75-4.55q-.375.4-.862.637Q6.55 14.5 6 14.5q-1.05 0-1.775-.725Q3.5 13.05 3.5 12q0-1.05.725-1.775Q4.95 9.5 6 9.5q.55 0 1.038.238.487.237.862.637l7.75-4.55q-.075-.2-.112-.413Q15.5 5.2 15.5 5q0-1.05.725-1.775Q16.95 2.5 18 2.5q1.05 0 1.775.725Q20.5 3.95 20.5 5q0 1.05-.725 1.775Q19.05 7.5 18 7.5q-.55 0-1.038-.238-.487-.237-.862-.637l-7.75 4.55q.075.2.113.412.037.213.037.413 0 .2-.037.412-.038.213-.113.413l7.75 4.55q.375-.4.862-.637Q17.45 16.5 18 16.5q1.05 0 1.775.725.725.725.725 1.775 0 1.05-.725 1.775-.725.725-1.775.725zm0-15q.625 0 1.062-.438Q19.5 5.625 19.5 5t-.438-1.062Q18.625 3.5 18 3.5t-1.062.438Q16.5 4.375 16.5 5t.438 1.062Q17.375 6.5 18 6.5zm-12 7q.625 0 1.062-.438Q7.5 12.625 7.5 12t-.438-1.062Q6.625 10.5 6 10.5t-1.062.438Q4.5 11.375 4.5 12t.438 1.062Q5.375 13.5 6 13.5zm12 7q.625 0 1.062-.438.438-.437.438-1.062t-.438-1.062Q18.625 17.5 18 17.5t-1.062.438Q16.5 18.375 16.5 19t.438 1.062q.437.438 1.062.438zM18 5zM6 12zm12 7z"}})])
          )
        }
      }
    